export const FETCH_CUSTOM_FIELDS = 'crm/customFields/FETCH_CUSTOM_FIELDS'
export const FETCH_CUSTOM_FIELDS_STARTED =
  'crm/customFields/FETCH_CUSTOM_FIELDS_STARTED'
export const FETCH_CUSTOM_FIELDS_SUCCESS =
  'crm/customFields/FETCH_CUSTOM_FIELDS_SUCCESS'
export const FETCH_CUSTOM_FIELDS_FAILED =
  'crm/customFields/FETCH_CUSTOM_FIELDS_FAILED'

export const FETCH_ALL_CUSTOM_FIELDS_STARTED =
  'crm/customFields/FETCH_ALL_CUSTOM_FIELDS_STARTED'
export const FETCH_ALL_CUSTOM_FIELDS_SUCCESS =
  'crm/customFields/FETCH_ALL_CUSTOM_FIELDS_SUCCESS'
export const FETCH_ALL_CUSTOM_FIELDS_FAILED =
  'crm/customFields/FETCH_ALL_CUSTOM_FIELDS_FAILED'

export const ADDRESS = 'ADDRESS'
export const DATE = 'DATE'
export const LINK = 'LINK'
export const MULTI_LINE = 'MULTI_LINE'
export const NUMBER = 'NUMBER'
export const SINGLE_LINE = 'SINGLE_LINE'
export const CUSTOM_FIELD_TYPES = [
  ADDRESS,
  DATE,
  LINK,
  MULTI_LINE,
  NUMBER,
  SINGLE_LINE,
]
